import { render, staticRenderFns } from "./ViewUrlDetail.vue?vue&type=template&id=0e15fe80"
import script from "./ViewUrlDetail.vue?vue&type=script&lang=js"
export * from "./ViewUrlDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports